import { BaseModal } from './BaseModal'
import { hintword, solution, unicodeSplit } from '../../lib/words'
import { Cell } from '../grid/Cell'
import {useState} from 'react'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const HintModal = ({ isOpen, 
  handleClose }: Props) => {
    const Hint = unicodeSplit(solution).slice(0,1)
    const [show, toggleShow] = useState(false);

  return (
    <BaseModal title="எழுத்து குறிப்பு" isOpen={isOpen} handleClose={handleClose}>   
      <div className="flex justify-center mb-1 mt-4" onClick={() => toggleShow(!show)}>
        {show ? '' : <Cell value="ⓘ" />}
        {show && Hint.map((word) => (
        <Cell isRevealing={true} isCompleted={true} value={word} status="correct" />))}
        <Cell value=" " /><Cell value=" " /><Cell value=" " /><Cell value=" " />
      </div>
    <div className="mt-5 italic text-2xl text-gray-500 dark:text-gray-300" 
    dangerouslySetInnerHTML={{ __html: hintword }} />
    </BaseModal>
  )
}